// utils/mapGeneration.js

import { TileType, UnitType } from './combatSystem';

export const GRID_SIZE = 12;

/**
 * Generate a random tactical map with cover
 */
export const generateMap = (gridSize = GRID_SIZE, coverCount = 25) => {
  const map = Array(gridSize).fill(null).map(() => 
    Array(gridSize).fill(TileType.EMPTY)
  );
  
  // Add cover strategically
  for (let i = 0; i < coverCount; i++) {
    const x = Math.floor(Math.random() * gridSize);
    const y = Math.floor(Math.random() * gridSize);
    map[y][x] = Math.random() > 0.5 ? TileType.FULL_COVER : TileType.HALF_COVER;
  }
  
  return map;
};

/**
 * Generate enemy units based on difficulty
 */
export const generateEnemies = (difficulty, count) => {
  const enemies = [];
  const baseHp = difficulty === 'easy' ? 3 : 
                 difficulty === 'medium' ? 4 : 
                 difficulty === 'hard' ? 5 : 6;
  
  for (let i = 0; i < count; i++) {
    enemies.push({
      id: `enemy-${i}`,
      type: UnitType.ENEMY,
      name: `Hostile-${i + 1}`,
      x: Math.floor(Math.random() * 4) + 7,
      y: Math.floor(Math.random() * 4) + 1,
      hp: baseHp,
      maxHp: baseHp,
      ap: 2,
      maxAp: 2
    });
  }
  
  return enemies;
};

/**
 * Convert squad data to battle units
 */
export const createSoldiersFromSquad = (squad, startX = 1, startY = 10) => {
  return squad.map((soldier, index) => ({
    id: soldier.id,
    type: UnitType.SOLDIER,
    name: soldier.name,
    rank: soldier.rank,
    x: startX + index,
    y: startY,
    hp: 5,
    maxHp: 5,
    ap: 2,
    maxAp: 2,
    kills: 0,
    loadout: soldier.loadout || {},
    originalData: soldier
  }));
};

/**
 * Get enemy count based on difficulty
 */
export const getEnemyCountForDifficulty = (difficulty) => {
  switch (difficulty) {
    case 'easy': return 3;
    case 'medium': return 4;
    case 'hard': return 5;
    default: return 6;
  }
};

/**
 * Initialize battle units from mission and squad data
 */
export const initializeBattleUnits = (mission, squad) => {
  const soldiers = createSoldiersFromSquad(squad);
  const enemyCount = getEnemyCountForDifficulty(mission.difficulty);
  const enemies = generateEnemies(mission.difficulty, enemyCount);
  
  return [...soldiers, ...enemies];
};

const mapGenerationUtils = {
  GRID_SIZE,
  generateMap,
  generateEnemies,
  createSoldiersFromSquad,
  getEnemyCountForDifficulty,
  initializeBattleUnits
};

export default mapGenerationUtils;